import type { AvailabilityWindow, SalesAvailability } from '@/modules/products/passes';

const weekdays = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
] as const;

function containsDate(window: AvailabilityWindow, date: string): boolean {
  const weekday = weekdays[new Date(`${date}T00:00:00Z`).getUTCDay()];
  return (
    (window.weekdays.length === 0 || window.weekdays.some((allowed) => allowed === weekday)) &&
    (window.startDate == null || date >= window.startDate) &&
    (window.endDate == null || date <= window.endDate)
  );
}

/** ADR 0073: inclusive valid dates, exclusions win, unrestricted exclusions exclude nothing. */
export function isPassOnSale(availability: SalesAvailability, date: string): boolean {
  const exclusion = availability.exclusionDays;
  const hasExclusions =
    exclusion.weekdays.length > 0 || exclusion.startDate != null || exclusion.endDate != null;
  return (
    containsDate(availability.validDays, date) && !(hasExclusions && containsDate(exclusion, date))
  );
}
